<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>To Catch a Thief</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="acknowledgePage" id="ack"><h2 class="acknowledgeHead">Acknowledgments</h2><p class="acknowledgeText"><span>In a world where distances loom large and the handling of books can become vastly impersonal, one group of people makes a daily, hourly difference in the reading experience.</span></p><p class="acknowledgeText"><span>It is my greatest pleasure to thank those extraordinary people here. I refer to all the extraordinary booksellers who cherish and protect the children of a writer’s heart.</span></p><p class="acknowledgeText"><span>You know who you are. But you may not realize how far your influence extends and how deeply you touch the lives of readers every day.</span></p><p class="acknowledgeText"><span>I hope you will accept my heartfelt thanks for all the thousand things you do to care for every new book you unpack from a box or straighten on a shelf.</span></p><p class="acknowledgeText"><span>I also want to send a special nod to Cindi in Wisconsin, Ellen in New Jersey, Sharon in Pennsylvania, Marcy and Tom in Oregon, Beth Anne in Colorado, Sharon in Ohio, Rosemary and Margaret in Australia, Kellie in Hawaii, Terry in Chicago, Penny and Janet in Indiana, Molly in Louisiana, and Phyllis, Kathy and Vicky in Arizona.</span></p><p class="acknowledgeText"><span>You are all totally amazing.</span></p><p class="acknowledgeText"><span>That’s why this one’s for you.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tocatchathief_ack.vue?7ca59d3a